module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative span-6-lg offset-1-lg span-6-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs debug ratio-flip-card testing-outer"
  }, [_c('div', {
    staticClass: "testing"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdc4ad54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/share_card.vue
// module id = 673
// module chunks = 1